import React, { ComponentProps, useState } from 'react';
import AdvancedModal from '@tovia/man-ui/lib/components/Modal/AdvancedModal';
import styled from 'styled-components/macro';
import { useSelector } from '../../redux';
import { UpgradeModal } from './UpgradeModal';
import { UpgradeButton } from './UpgradeButton';
import { ApiClient } from '../../helpers';
import urls, { constructUrl } from 'src/shared/urls';

type Props = ComponentProps<typeof AdvancedModal>;

export const UpgradePurchaseDialog = (props: Props) => {
  const site = useSelector((state) => state.site);
  const { joinSubdomain } = useSelector((state) => state.app);

  const [error, setError] = useState('');
  const [purchasing, setPurchasing] = useState(false);
  const [success, setSuccess] = useState(false);

  const purchase = async () => {
    setPurchasing(true);

    try {
      const api = new ApiClient();
      const purchaseEndpoint = constructUrl(urls.post.purchase.upgrade);

      const {
        body: { success, cartItem },
      } = await api.post(purchaseEndpoint, {});

      setSuccess(success);

      if (!success) {
        const location = `https://${joinSubdomain}.${site.domain}/purchase/upgrade/?cartItemUUID=${
          cartItem.cartItemUUID
        }&amount=10.00&currency=USD&iframeURL=${encodeURIComponent(cartItem.iframeURL)}`;

        window.location.assign(location);
      } else {
        setTimeout(() => {
          window.location.reload();
        }, 7000);
      }
    } catch (error) {
      let message = 'Submission failed, please try again later or contact support';

      if (error.response.statusCode === 403) {
        message = 'Please login to complete this purchase';
      }

      setError(message);
      setPurchasing(false);
    }
  };

  return (
    <UpgradeModal {...props}>
      <p>We&apos;re sorry - You have reached the download limit for your account.</p>
      <p>Upgrade to premium! A one time $10.00 fee unlocks unlimited downloads for the life of your membership.</p>
      <p>Click below and immediately receive your full access.</p>
      {!success ? (
        <UpgradeButton loading={purchasing} type="submit" onClick={purchase} disabled={!!error}>
          Upgrade Now!
        </UpgradeButton>
      ) : (
        <>
          <Success>Success! Thank you for purchasing!</Success>
          <span>Please wait while we load your purchase...</span>
        </>
      )}
      {error ? <Error>{error}</Error> : null}
    </UpgradeModal>
  );
};

const Success = styled.span`
  font-size: 1.25rem;
  font-weight: 700;
  display: block;
  margin: 30px 0 0;
`;

const Error = styled.span`
  color: #c20000;
  display: block;
  margin: 4px 0 0;
`;
